export enum AlertType {
  CRITICAL = "critical",
  INFORMATIVE = "informative",
}

export enum AlertComparizonType {
  ABOVE = "above",
  BELOW = "below",
}

export enum AlertValueType {
  PERCENTAGE = "percentage",
  ABSOLUTE = "absolute",
  DEVIATION = "deviation",
  INSUFFICIENT_DATA = "insufficient data",
}

export interface Alert {
  id: number;
  alert_type: AlertType;
  signal_type: string;
  comparison_type: AlertComparizonType;
  value_type: AlertValueType;
  minimal_count: number;
  value: number;
  user_id?: number | null;
  is_active?: boolean;
}
